export default __webpack_public_path__ + "static/stroke-square-da00534607df51ee0fda254db3f62e24.mp4";